export default __webpack_public_path__ + "static/media/76.12e7fee2.jpeg";